import React, { useState, useEffect, useContext } from 'react';
import axiosConfig from '../../../../utils/axiosConfig';
import { Formik, Form, Field } from 'formik';
import { fieldToTextField, TextField, TextFieldProps, Select, Switch } from 'formik-material-ui';
import {
    Box, Button, Dialog, DialogActions,
    DialogContent, DialogContentText, DialogTitle,
    FormHelperText, Grid, List, ListItem, ListItemText,
    MenuItem, Slide, Typography
} from '@material-ui/core';

import Alert from '@material-ui/lab/Alert';
import { StateContext, DispatchContext } from '../../../../context/Provider';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const StudentModalForm = (props) => {

    const appState = useContext(StateContext);
    const appDispatch = useContext(DispatchContext);
    const { globalState, facultyState } = appState;
    const { globalDispatch, facultyDispatch } = appDispatch;

    const [errorMessages, setErrorMessages] = useState([]);
    const [student, setStudent] = useState({
        name: '',
        lrn: '',
        email: ''
    });

    async function createStudent(values, resetForm) {

        try {
            const res = await axiosConfig.post(`/students`, {
                role_id: 5,
                name: values.name,
                lrn: values.lrn,
                email: values.email
            });
    
            if (res.data.status_code == 'ok') {
                globalDispatch({type: 'setSnackbarMsg', value: 'Student created successfully.'});
                globalDispatch({type: 'setIsOpenSnackbar', value: true});
    
                props.fetchStudents();
                props.handleClose();
    
            } else {
                console.log(res);
            }

        } catch (err) {
            if (err.response.status === 422) {
                const errors = err.response.data.errors;

                let errorMsgs = [];
                Object.keys(errors).map((error, index) => {
                    if (errors[error].length > 0) {
                        errors[error].map((err1, index1) => {
                            errorMsgs.push(err1);
                        });
                    } else {
                        errorMsgs.push(errors[error][0]);
                    }
                });

                setErrorMessages(errorMsgs);
            }
        }

        globalDispatch({type: 'setIsLoading', value: false});
        setTimeout(() => {
            globalDispatch({type: 'setIsOpenSnackbar', value: false});
        }, 1200);
    }

    async function updateStudent(values, resetForm) {

        try {
            const res = await axiosConfig.post(`/students/${props.selectedStudent.id}`, {
                _method: 'PATCH',
                role_id: 5,
                user_id: props.selectedStudent.id,
                name: values.name,
                lrn: values.lrn,
                email: values.email
            });
    
            if (res.data.status_code == 'ok') {
                globalDispatch({type: 'setSnackbarMsg', value: 'Student updated successfully.'});
                globalDispatch({type: 'setIsOpenSnackbar', value: true});
    
                props.fetchStudents();
                props.handleClose();
            } else {
                console.log(res);
            }

        } catch (err) {
            if (err.response.status === 422) {
                const errors = err.response.data.errors;

                let errorMsgs = [];
                Object.keys(errors).map((error, index) => {
                    if (errors[error].length > 0) {
                        errors[error].map((err1, index1) => {
                            errorMsgs.push(err1);
                        });
                    } else {
                        errorMsgs.push(errors[error][0]);
                    }
                });

                setErrorMessages(errorMsgs);
            }
        }

        globalDispatch({type: 'setIsLoading', value: false});
        setTimeout(() => {
            globalDispatch({type: 'setIsOpenSnackbar', value: false});
        }, 1200);
    }

    useEffect(() => {

        setErrorMessages('');
        
        if (props.selectedStudent) {
            setStudent({
                name: props.selectedStudent.name,
                lrn: props.selectedStudent.lrn,
                email: props.selectedStudent.email
            });
        }
        
    }, [props.selectedStudent]);

    return (
        <Dialog 
            open={props.open} 
            onClose={props.handleClose} 
            aria-labelledby="form-dialog-title"
            fullWidth={true} 
            maxWidth={'sm'}
            TransitionComponent={Transition}
            disableBackdropClick 
        >
            <Formik
                initialValues={student}
                validate={(values) => {
                    const errors = {};

                    if (!values.name) {
                        errors.name = 'This field is required';
                    }

                    if (!values.lrn) {
                        errors.lrn = 'This field is required';
                    }

                    if (!values.email) {
                        errors.email = 'This field is required';
                    }

                    return errors;
                }}
                onSubmit={(values, {setSubmitting, resetForm}) => {

                    setSubmitting(false);
                    globalDispatch({type: 'setIsLoading', value: true});

                    // setTimeout(() => {
                    //     setSubmitting(false);
                    //     alert(JSON.stringify(values, null, 2));
                    //     resetForm();
                    //     globalDispatch({type: 'setIsLoading', value: false});
                    // }, 500);

                    if (props.selectedStudent === null) {
                        createStudent(values, resetForm);
                    } else {
                        updateStudent(values, resetForm);
                    }
                }}
            >
                {({submitForm, isSubmitting, touched, errors}) => (
                    <Form>
                        <DialogTitle id="form-dialog-title">
                            {props.dialogTitle}
                        </DialogTitle>
                        <DialogContent>
                            <Grid container alignItems="flex-start" spacing={2}>

                                {errorMessages.length > 0 && (
                                    <Grid item xs={12}>
                                        <Alert variant="filled" severity="error" style={{width: '100%'}}>
                                            {errorMessages.map((key, i) => (
                                                <Typography key={i}>
                                                    {key}
                                                </Typography>
                                            ))}
                                        </Alert>
                                    </Grid>
                                )}

                                <Grid item xs={12}>
                                    <Field
                                        component={TextField}
                                        label="Full Name (required)"
                                        name="name"
                                        fullWidth
                                        variant="outlined"
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <Field
                                        component={TextField}
                                        label="Learner's Reference No. (required)"
                                        name="lrn"
                                        fullWidth
                                        variant="outlined"
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <Field
                                        component={TextField}
                                        label="Email Address (required)"
                                        name="email"
                                        fullWidth
                                        variant="outlined"
                                    />
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button 
                                onClick={props.handleClose} 
                                disabled={isSubmitting} 
                                color="secondary"
                            >
                                Cancel
                            </Button>
                            <Button
                                disabled={isSubmitting} 
                                onClick={submitForm} color="primary"
                            >
                                Submit
                            </Button>
                        </DialogActions>
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
}

export default StudentModalForm;